import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { observable, computed } from 'mobx';
import { UIState } from 'data/UIState';
import { observer } from 'mobx-react';
import { AccountProfile } from 'components/account/AccountProfile';

import './ProfileSubPage.pcss';
import {NavAvatar} from "components/nav/NavAvatar";
import UserDataSource from "data/UserDataSource";
import {Transport} from "data/transport";

@observer
class ProfileSubPage extends React.Component {
  render() {
    return UIState.isProfile ? <Profile /> : null;
  }
}

@observer
class Profile extends React.Component {

  @observable bio:string;
  @observable editingBio:boolean = false;
  @observable disableEditBio:boolean = false;

  @observable street:string;
  @observable apt:string;
  @observable city:string;
  @observable _state:string;
  @observable zip:string;
  @observable editingAddress:boolean = false;
  @observable deleteAccountAuthMode:boolean = false;

  @computed 
  get addressMissing() {
    return !this.street && !this.apt && !this.city && !this._state && !this.zip;
  }

  loadGoalsSettings = () => {
		//ReactDOM.render(<AccountProfile />, document.getElementById('fullbrowserbody'));
	}

  editBio = () => {
    this.bio=UIState.user.bio;
    this.editingBio=true;
    this.disableEditBio = false;
  }

  cancelEditBio = () => {
    this.editingBio=false;
  }

  saveBio = () => {
    this.disableEditBio = true;
    UserDataSource.saveUserBio(UIState.user, this.bio)
      .then(()=>{
        this.editingBio=false;
        this.disableEditBio = false;
      })
      .catch(()=>{
        alert('Save failed! Your Internet connection may be unstable. Please try to save again.');
        this.disableEditBio = false;
      })
  }

  beginDeleteAccount = () => {
    this.deleteAccountAuthMode = true;
  }

  cancelDeleteAccount = () => {
    this.deleteAccountAuthMode = false;
  }

  render() {
    const dataExportUrl = Transport.URL('/exportAccount');
    return (
      <div className="profileSubPage">
        
        {this.deleteAccountAuthMode ?
        <ConfirmDeleteAccount onCancel={this.cancelDeleteAccount} />
        :  
        <React.Fragment>

          <div className="top">
            <div className="block">
              <NavAvatar user={UIState.user} variant={'xlarge'} />
              <div className={'name-and-email'}>
                <h2 className={'level2'}>{UIState.user.firstName} {UIState.user.lastName}{UIState.user.nickname && <React.Fragment>&nbsp;(@{UIState.user.nickname})</React.Fragment>}</h2>
                <h3 className={'level3'}>{UIState.user.email}</h3>
              </div>
              <div className="action">
                <button aria-label="Edit your profile" onClick={this.loadGoalsSettings}><i aria-hidden={true} className="fa fa-pencil"></i></button>
              </div>

            </div>
          </div>

          <hr />

          <div className="block">
            <h2 className={'level2'}>Need Help?</h2>
            <p>If you have any questions or need help, please send an email to <a href="mailto:strive@well-concepts.com">strive@well-concepts.com</a></p>
          </div>
          <hr />


          <div className="block">
            <h2 className={'level2'}>Your Data</h2>
            <p>Export a copy of all data stored in The Wellness Concepts Engage Platform related to you. This export will be in
              JSON format. JSON viewers are available readily on the Internet. Simply copy and paste the result of this export into the
              viewer of your choice.
            </p>
            <a className="button simple" target="_blank" aria-label={`Export, opens new tab`} href={dataExportUrl}>Export</a>
          </div>
          <hr />
          <div className="block">
            <h2 className={'level2'}>Privacy &amp; Consent</h2>
            <div className={"para"}>During signup you reviewed and accepted our <a href={UIState.settings.TOS_DOC} target="_blank" aria-label={`Terms of Service and Privacy Policy, opens new tab`}>terms of service &amp; privacy policy</a>.

              {UIState.settings.ENABLE_GDPR && UIState.settings.GDPR_ITEMS.length>0 ?
                <>
                  &nbsp;You also gave consent for the following items:
                  <ul>
                  {UIState.settings.GDPR_ITEMS.map(item=><li key={item.id}>{item.profileDescription}</li>)}
                  </ul>
                  You may delete your account at any time to revoke this consent
                  {UIState.settings.ENABLE_SAML_SSO && <>&nbsp;by sending an email to <a href="mailto:strive@well-concepts.com">strive@well-concepts.com</a>. Include your contact information and company with your request</>}
                  .
                </>
              :
                <>
                  &nbsp;You may delete your account at any time
                  {UIState.settings.ENABLE_SAML_SSO && <>&nbsp;by sending an email to <a href="mailto:strive@well-concepts.com">strive@well-concepts.com</a>. Include your contact information and company with your request</>}
                  .
                </>
              }
              &nbsp;Please note, account deletion is a permanent.
            </div>
            {UIState.settings.ENABLE_SAML_SSO ?
              <p></p>
              :
              <button className="simple" onClick={this.beginDeleteAccount}>Delete Account</button>
            }
          </div>
          <hr />
          

        </React.Fragment>
        }
      </div>
    );
  }
}


@observer
class ConfirmDeleteAccount extends React.Component<{onCancel:()=>void}> {
  @observable email:string;
  @observable password:string;
  @observable deleting:boolean = false;
  @observable error:boolean = false;

  handleCancel = () => {
    this.email = '';
    this.password = '';
    this.deleting = false;
    this.props.onCancel();
  }

  attemptDeletion = () => {
    if(!this.email || !this.password) {
      alert('Your Email and Password are required to delete your account.');
    } else {      
      this.deleting = true;
      UIState.deleteAccount(this.email, this.password)
      .then(()=>{
        document.location.href = '/';
      })
      .catch(()=>{
        alert('Failed to delete account. Please try again. If this problem persists, contact support@well-concepts.com for assistance.')
        this.error = true;
        this.deleting = false;
      })
    }
  }

  render() {
    return(
      <div className="block" style={{marginTop:'36px'}}>
        <h2>Account Deletion Confirmation</h2>
        <p>Deleting your account is permanent. There will be no way to recover your data, it will be completely
          purged from our system. Please confirm by entering your correct email and password.
        </p>
        {this.error &&
          <p className="error">There was a problem trying to delete your account. Please try again. If the problem persists, please
          contact Wellness Concepts support for help using <a href="mailto:strive@well-concepts.com">strive@well-concepts.com</a>.</p>
        }
        <input disabled={this.deleting} value={this.email} onChange={(e)=>{ this.email = e.target.value; }} placeholder="email" type="text"/><br/>
        <input disabled={this.deleting} value={this.password} onChange={(e)=>{ this.password = e.target.value; }}placeholder="password" type="password"/><br/>
          <button className="simple" onClick={this.attemptDeletion}>Delete My Account</button>
          <button style={{float:'right'}} onClick={this.handleCancel}>CANCEL</button>
      </div>
    );
  }
}



export { ProfileSubPage };
